/**
 * Merges filter option lists fetched per site into one list, round-robin so every site is fairly
 * represented, and drops repeats. Options are deduped by `value`, falling back to `trackingKey`;
 * options carrying neither are dropped.
 */
export const mergeAndDedupeOptions = <T extends { value?: string; trackingKey?: string }>(
	optionLists: readonly (readonly T[])[],
): T[] => {
	const seen = new Set<string>();
	const merged: T[] = [];
	const longest = optionLists.reduce((max, options) => Math.max(max, options.length), 0);

	for (let index = 0; index < longest; index++) {
		for (const options of optionLists) {
			const option = options[index];
			if (!option) {
				continue;
			}

			// `||` not `??`: an empty-string value is not a usable key, so fall back to trackingKey.
			const dedupeKey = option.value || option.trackingKey;
			if (!dedupeKey || seen.has(dedupeKey)) {
				continue;
			}

			seen.add(dedupeKey);
			merged.push(option);
		}
	}

	return merged;
};
